import {Component, OnInit} from '@angular/core';
import {HttpService} from '../../../_service/http.service';
import {ActivatedRoute, Router} from '@angular/router';
import {OrganizationService} from '../../../_service/organization.service';
import {isNullOrUndefined} from "util";

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css', '../../../../css/main.css']
})
export class MeterWidgetAuthComponent implements OnInit {

  accountNumber: string;
  phoneNumber: string;
  authorized: boolean;
  errorMessage: string;
  accountError: string;
  phoneError: string;
  alias: string;

  constructor(private http: HttpService, private route: ActivatedRoute,
              private organizationService: OrganizationService, private router: Router) {
  }

  ngOnInit() {
    this.alias = this.route.snapshot.params.alias;
    // this.organizationService.isAliasExist(this.alias).then(
    //   (isAliasExist) => {
    //     if (!isAliasExist) {
    //       this.router.navigate(['error']);
    //     }
    //     console.debug("Is ALias exists: ", isAliasExist);
    //   });


    this.accountNumber = this.route.snapshot.queryParams['accountNumber'];
  }

  authorize() {
    console.debug('In authorize', this.accountNumber);
    this.checkData();
    if (this.accountError != null || this.phoneError != null) {
      return;
    }

    this.phoneNumber = this.phoneNumber.trim();
    this.accountNumber = this.accountNumber.trim();

    // this.http.postData('/rest/meter_widget/' + localStorage.getItem('organizationAlias')
    this.http.postData('rest/meter_widget/' + this.alias
      + '/postAuthInfo', {accountNumber: this.accountNumber, phoneNumber: this.phoneNumber})
      .then((data) => {
        console.debug('Post auth info result', data);
        this.authorized = true;
      }, (error) => {
        console.warn('Post auth info erro', error);
        this.errorMessage = error._body;
      });

  }

  checkData() {
    console.debug('checking data phone', this.phoneNumber);
    console.debug('checking data acc', this.accountNumber);

    this.accountError = null;
    this.phoneError = null;

    if (this.accountNumber == null || this.accountNumber == '') {
      this.accountError = 'Укажите Ваш лицевой счет';
    }

    if (this.phoneError == null && (isNullOrUndefined(this.phoneNumber) || !this.isPhoneNumberFormatCorrect(this.phoneNumber.trim()))) {
      this.phoneError = 'Укажите Ваш телефон в формате +79998887766';
    }

    if (this.accountError == null && !this.isAccountNumberFormatCorrect(this.accountNumber.trim())) {
      this.accountError = 'Номер лицевого счета может состоять только из цифр';
    }

    if (this.phoneError != null || this.accountError != null) {
      return;
    }
  }

  isPhoneNumberFormatCorrect(phoneNumber: string) {
    const phoneRegexp = new RegExp(/^(7|8|\+7)?(\d{10})$/);
    return phoneRegexp.test(phoneNumber);
  }

  isAccountNumberFormatCorrect(accountNumber: string) {
    console.debug('Checking acc ', accountNumber);
    const accountRegexp = new RegExp(/^[0-9]+$/);
    return accountRegexp.test(accountNumber);
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/send-values-widget/auth/auth.component.ts